import { CallingState, CancelCallButton, OwnCapability, ReactionsButton, Restricted, ScreenShareButton, SpeakerLayout, SpeakingWhileMutedNotification, ToggleAudioPublishingButton, ToggleVideoPublishingButton, useCall, useCallStateHooks } from "@stream-io/video-react-sdk";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LayoutWithTopBar } from "../../components/LayoutWithTopBar";
import Loader from "./components/Loader";
import { useStream } from "../../hooks/useStream";

interface CallPageProps {
    
}

const CallPage: React.FC<CallPageProps> = () => {
    const navigate = useNavigate();
    const call = useCall();
    const { useCallCallingState } = useCallStateHooks();
    const callingState = useCallCallingState();
    const { leaveCall, currentCallData } = useStream();

    useEffect(() => {
        if(currentCallData === null) {
            navigate(-1);
        }
    }, [currentCallData]);

    return <LayoutWithTopBar
        onClickPrevArrow={() => navigate(-1)}
        hideLineActiveCall={true}
    >
        {
            call && callingState === CallingState.JOINED ? (
                <div className="text-white max-w-full max-h-full flex flex-col">
                    <div className="flex-1 relative flex overflow-y-auto">
                        <SpeakerLayout />
                    </div>
                    <div className="flex-none">
                        <div className="str-video__call-controls">
                            <Restricted requiredGrants={[OwnCapability.SEND_AUDIO]}>
                                <SpeakingWhileMutedNotification>
                                    <ToggleAudioPublishingButton />
                                </SpeakingWhileMutedNotification>
                            </Restricted>
                            <Restricted requiredGrants={[OwnCapability.SEND_VIDEO]}>
                                <ToggleVideoPublishingButton />
                            </Restricted>
                            <Restricted requiredGrants={[OwnCapability.CREATE_REACTION]}>
                                <ReactionsButton />
                            </Restricted>
                            <CancelCallButton onLeave={() => {
                                leaveCall();
                            }} />
                        </div>
                    </div>
                </div>
            ) : (
                <Loader />
            )
        }
            
    </LayoutWithTopBar>
}

export default CallPage;